import type { IUserCompanyFunction } from '@condo/domain';
import { getClient } from '@/shared/api/client';

/**
 * Fetch user company functions from basecamp API
 * Ported from Vue project: /services/core/cockpit/src/api/user.api.ts fetchUserCompanyFunctions
 */
export const fetchUserCompanyFunctions = async (): Promise<IUserCompanyFunction[]> => {
    const { data } = await getClient('basecamp').get('/users/company-functions');
    return data.userCompanyFunctions;
};
